//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '../../../src/lib/util';
import {
    formatDate
} from '../../../src/lib/date';

export default {
    name: 'orderInfo',
    data() {
        const vm = this;
        return {
            orderId: 0,
            loading: false,
            imageUrl: util.ApiUrl + '/file/download/',
            contactInformation: {}
        };
    },
    filters: {
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    methods: {
        getOrder() {
            this.loading = true;
            this.$store.dispatch({
                type: 'order/getOrderById',
                id: this.orderId
            }).then(() => {

            }).finally(() => {
                this.loading = false;
            });
        },
        getContactInformation(order) {
            console.log(order);
            if (order.conttactInformationId != undefined && order.conttactInformationId != 0) {
                this.loading = true;
                this.$store.dispatch({
                    type: 'order/getContactInformation',
                    id: this.orderId
                }).then(() => {
                    this.contactInformation = this.$store.state.order.contactInformation;
                    console.log(this.contactInformation);
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    },
    created() {
        this.orderId = parseInt(this.$route.params.id || 0);
        this.getOrder();
        if (this.order) {
            this.getContactInformation(this.order);
        }
    },
    computed: {
        order() {
            return this.$store.state.order.orderInfo;
        }
    },
    mounted() {

    },
    watch: {
        // $route: {
        //     handler: function (val, oldVal) {
        //         this.orderId = parseInt(this.$route.params.id || 0);
        //         if (this.orderId != 0) {
        //             this.getOrder();
        //         }
        //         if (this.order) {
        //             this.getContactInformation(this.order);
        //         }
        //     },
        //     deep: true
        // }
    }
};
